import { Box, CircularProgress, SxProps, Theme, Typography } from '@mui/material';

type TStyles = {
  container: SxProps<Theme>;
};
const styles: TStyles = {
  container: {
    minHeight: 320,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
};

export const LoadingQRCode = () => {
  return (
    <Box data-testid="electronic-signature-loader" sx={styles.container}>
      <CircularProgress />
      <Typography>Формуємо QR-код для Дії...</Typography>
    </Box>
  );
};
